import React from "react";

const JQuery_Intro = () => {
  return (
    <div>
      <h1>JQuery_Intro</h1>
      <p>Placeholder component for: "JQuery_Intro"</p>
    </div>
  );
};

export default JQuery_Intro;
